export interface WordItem {
  id: string;
  word: string;
  partOfSpeech: string;
  difficultyLevel?: string;
  definition: string;
  example: string;
  exampleSentence?: string;
  synonyms: string[];
  antonyms?: string[];
  tags?: string[];
  phonetic?: string;
  premiumContent?: boolean;
  flagged?: boolean;
  groupId?: string;
  listId?: string;
  createdOn?: string;
  lastUpdateOn?: string;
}

export interface WordGroup {
  id: string;
  name: string;
  title?: string;
  groupOrderNumber?: number | null;
  listId?: string;
  listName?: string;
  description: string;
  createdOn?: string;
  lastUpdateOn?: string;
  createdByName?: string;
  createdByEmail?: string;
  wordCount?: number;
  words: WordItem[];
}

export interface WordList {
  id: string;
  listId: string;
  title: string;
  listNumber?: number | null;
  icon?: string;
  colorTheme?: string;
  listType: string;
  createdOn?: string;
  lastUpdateOn?: string;
  createdByName?: string;
  createdByEmail?: string;
  groupCount?: number;
  wordCount?: number;
  name?: string; // backwards compatibility
  category?: string;
  description?: string;
  groups: WordGroup[];
}

export const LIST_TYPE_OPTIONS = [
  { label: "Grouped Synonyms", value: "GROUPED_SYNONYMS" },
  { label: "Dictionary AZ", value: "DICTIONARY_AZ" },
];

export const INITIAL_WORD_LISTS: WordList[] = [];

const LOCAL_STORAGE_KEY = "wordzapp_trainer_lists_v2";

export const getStoredWordLists = (): WordList[] => {
  try {
    const saved = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (saved) {
      const parsed: WordList[] = JSON.parse(saved);
      if (Array.isArray(parsed)) {
        return parsed.map((item) => ({
          ...item,
          id: item.id || item.listId,
          listId: item.listId || item.id,
          title: item.title || item.name || "Untitled List",
          listType: item.listType || "GROUPED_SYNONYMS",
          groups: item.groups || [],
        }));
      }
    }
  } catch (e) {
    console.error("Error reading wordzapp lists from storage", e);
  }
  return [];
};

export const saveStoredWordLists = (lists: WordList[]): void => {
  try {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(lists));
  } catch (e) {
    console.error("Error writing wordzapp lists to storage", e);
  }
};
